import React, { useState } from "react";

export default function UserProfile() {
    const [selectedTab, setSelectedTab] = useState("personal");
    const [name, setName] = useState("Zaid");
    const [email, setEmail] = useState("info@gmail.com");
    const [phone, setPhone] = useState("+962 79 123 1234");
    const [educationLevel, setEducationLevel] = useState("Undefined");

    const [city, setCity] = useState("");
    const [birthday, setBirthday] = useState("");
    const [grade, setGrade] = useState("");
    const [gender, setGender] = useState("male");
    const [aboutYou, setAboutYou] = useState("");
    const [profilePhoto, setProfilePhoto] = useState(""); 

    const content = {
        personal: (
            <div className="flex flex-col gap-[20px]">
                <div className="flex items-center gap-[7px]">
                    <div className="w-[35px] h-[35px] bg-[#09778E] rounded-full flex items-center justify-center">
                        <img className="w-[20px] h-[20px]" src={require("../../assets/icons/user.svg").default} alt="" />
                    </div>
                    <div className="font-20-px text-[25px] font-bold text-[#09778E] capitalize">Personal Information</div>
                </div>

                <form>
                    <div className="flex flex-col gap-[12px]">
                        <div className="w-full flex flex-col gap-2">
                            <label className="block text-sm font-bold text-[#09778E] capitalize">Your name</label>
                            <input
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="py-2 px-4 border border-[#09778E] rounded-[4px] outline-none "
                                placeholder="Enter your name"
                            />
                        </div>
                        <div className="w-full flex flex-col gap-2">
                            <label className="block text-sm font-bold text-[#09778E] capitalize">Your Email</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="py-2 px-4 border border-[#09778E] rounded-[4px] outline-none "
                                placeholder="Enter your email"
                            />
                        </div>

                        <div className="w-full flex flex-col gap-2">
                            <label className="block text-sm font-bold text-[#09778E] capitalize">Your phone number</label>
                            <input
                                type="text"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                className="py-2 px-4 border border-[#09778E] rounded-[4px] outline-none "
                                placeholder="Enter your phone number"
                            />
                        </div>
                        <div className="w-full flex flex-col gap-2">
                            <label className="block text-sm font-bold text-[#09778E] capitalize">Your Education level</label>
                            <input
                                type="text"
                                value={educationLevel}
                                onChange={(e) => setEducationLevel(e.target.value)}
                                className="py-2 px-4 border border-[#09778E] rounded-[4px] outline-none "
                                placeholder="Enter your education level"
                            />
                        </div>

                        <button type="submit" className="w-100 w-fit bg-[#09778E] text-white font-bold py-2 px-6 rounded-[4px] mt-4">
                            Edit Information
                        </button>
                    </div>
                </form>
            </div>
        ),
        additional: (
            <div className="space-y-6">
                <div className="flex items-center gap-[7px]">
                    <div className="w-[35px] h-[35px] bg-[#09778E] rounded-full flex items-center justify-center">
                        <img className="w-[20px] h-[20px]" src={require("../../assets/icons/user.svg").default} alt="" />
                    </div>
                    <div className="font-20-px text-[25px] font-bold text-[#09778E] capitalize">Additional Information</div>
                </div>

                <form>
                    <div className="flex flex-col gap-[12px]">
                        <div className="flex items-center gap-4">
                            <div className="w-[50px] h-[50px] bg-gray-300 rounded-full flex items-center justify-center">
                                <img
                                    className="w-[30px] h-[30px] rounded-full"
                                    src={profilePhoto || "https://via.placeholder.com/30"}
                                    alt="Profile"
                                />
                            </div>
                            <button
                                onClick={() => document.getElementById("photoInput").click()}
                                className="py-[8px] px-[20px] bg-[#09778E] text-white rounded-[4px]"
                            >
                                Edit Photo
                            </button>
                            <input
                                id="photoInput"
                                type="file"
                                accept="image/*"
                                onChange={(e) => handlePhotoChange(e)}
                                style={{ display: "none" }}
                            />
                        </div>

                        <div className="flex items-center gap-[7px]">
                            <div className="flex items-center gap-2">
                                <input
                                    type="radio"
                                    id="male"
                                    name="gender"
                                    value="male"
                                    checked={gender === "male"}
                                    onChange={() => setGender("male")}
                                    className="cursor-pointer"
                                />
                                <label htmlFor="male" className="text-[#09778E]">Male</label>
                            </div>
                            <div className="flex items-center gap-2">
                                <input
                                    type="radio"
                                    id="female"
                                    name="gender"
                                    value="female"
                                    checked={gender === "female"}
                                    onChange={() => setGender("female")}
                                    className="cursor-pointer"
                                />
                                <label htmlFor="female" className="text-[#09778E]">Female</label>
                            </div>
                        </div>

                        <div className="flex flex-wrap gap-4">
                            <div className="w-full flex flex-col gap-2">
                                <label className="block text-sm font-bold text-[#09778E] capitalize">Your City</label>
                                <select
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                    className="py-2 px-4 border border-[#09778E] rounded-[4px]"
                                >
                                    <option value="">Select your city</option>
                                    <option value="Amman">Amman</option>
                                    <option value="Zarqa">Zarqa</option>
                                    <option value="Irbid">Irbid</option>
                                </select>
                            </div>
                            <div className="w-full flex flex-col gap-2">
                                <label className="block text-sm font-bold text-[#09778E] capitalize">Your Birthday</label>
                                <input
                                    type="date"
                                    value={birthday}
                                    onChange={(e) => setBirthday(e.target.value)}
                                    className="py-2 px-4 border border-[#09778E] rounded-[4px]"
                                />
                            </div>
                            <div className="w-full flex flex-col gap-2">
                                <label className="block text-sm font-bold text-[#09778E] capitalize">Your Grade</label>
                                <select
                                    value={grade}
                                    onChange={(e) => setGrade(e.target.value)}
                                    className="py-2 px-4 border border-[#09778E] rounded-[4px]"
                                >
                                    <option value="">Select your grade</option>
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                    <option value="C">C</option>
                                </select>
                            </div>
                        </div>

                        <div className="w-full flex flex-col gap-2">
                            <label className="block text-sm font-bold text-[#09778E] capitalize">About You</label>
                            <textarea
                                value={aboutYou}
                                onChange={(e) => setAboutYou(e.target.value)}
                                className="py-2 px-4 border border-[#09778E] rounded-[4px] outline-none"
                                placeholder="Tell us a bit about yourself..."
                            ></textarea>
                        </div>

                        <button type="submit" className="w-100 w-fit bg-[#09778E] text-white font-bold py-2 px-6 rounded-[4px] mt-4">
                            Add Information
                        </button>
                    </div>
                </form>
            </div>
        ),
        password: (
            <div className="flex flex-col gap-[20px]">
                <div className="flex items-center gap-[7px]">
                    <div className="w-[35px] h-[35px] bg-[#09778E] rounded-full flex items-center justify-center">
                        <img className="w-[20px] h-[20px]" src={require("../../assets/icons/edit.svg").default} alt="" />
                    </div>
                    <div className="font-20-px text-[25px] font-bold text-[#09778E] capitalize">Edit Password</div>
                </div>
                <div className="pl-[10px]">
                    <form>
                        <div className="flex flex-col gap-[12px]">
                            <div className="flex flex-col gap-[5px]">
                                <label className="block text-sm font-bold text-[#09778E] capitalize ">Current Password</label>
                                <input type="password" className="py-2 px-4 border rounded-[4px] w-full outline-none border-[1px] border-[#09778E]" placeholder="Enter Current password" />
                            </div>
                            <div className="flex flex-col gap-[5px]">
                                <label className="block text-sm font-bold text-[#09778E] capitalize ">New Password</label>
                                <input type="password" className="py-2 px-4 border rounded-[4px] w-full outline-none border-[1px] border-[#09778E]" placeholder="Enter new password" />
                            </div>
                            <div className="flex flex-col gap-[5px]">
                                <label className="block text-sm font-bold text-[#09778E] capitalize ">Confirm New Password</label>
                                <input type="password" className="py-2 px-4 border rounded-[4px] w-full outline-none border-[1px] border-[#09778E]" placeholder="Confirm new password" />
                            </div>
                            <button type="submit" className="w-100 w-fit bg-[#09778E] text-white font-bold py-2 px-6 rounded-md">Save Changes</button>
                        </div>
                    </form>
                </div>
            </div>
        )
    };

    const handlePhotoChange = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setProfilePhoto(reader.result); 
        };
        if (file) {
            reader.readAsDataURL(file);
        }
    };

    return (
        <section className="relative py-[40px]">
            <div className="container flex flex-col gap-[40px]">
                <div className="flex items-center gap-[2px] font-bold text-[40px]">
                    Personal <span className="text-[#09778E]">Profile</span>
                </div>
                <div className="flex flex-col gap-[40px]">
                    <div className="flex items-center gap-[7px] flex-wrap">
                        <div
                            onClick={() => setSelectedTab("personal")}
                            className={`w-100 py-[10px] px-[30px] font-bold rounded-[4px] border-[1px] capitalize cursor-pointer ${selectedTab === "personal" ? "bg-[#09778E] text-white" : "bg-white text-[#09778E]"}`}
                        >
                            Personal Information
                        </div>
                        <div
                            onClick={() => setSelectedTab("additional")}
                            className={`w-100 py-[10px] px-[30px] font-bold rounded-[4px] border-[1px] capitalize cursor-pointer ${selectedTab === "additional" ? "bg-[#09778E] text-white" : "bg-white text-[#09778E]"}`}
                        >
                            Additional Information
                        </div>
                        <div
                            onClick={() => setSelectedTab("password")}
                            className={`w-100 py-[10px] px-[30px] font-bold rounded-[4px] border-[1px] capitalize cursor-pointer ${selectedTab === "password" ? "bg-[#09778E] text-white" : "bg-white text-[#09778E]"}`}
                        >
                            Change Password
                        </div>
                    </div>

                    <div className="mt-[20px] p-[20px] border-[1px] border-[#f0f0f0] rounded-[4px] bg-white">
                        {content[selectedTab]}
                    </div>
                </div>
            </div>
        </section>
    );
}
